import './polyfills';
import { Logger } from './app/core/logger.service';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { ENVIRONMENT } from './app/environment/environment';

if (ENVIRONMENT.isProduction) {
  Logger.setProductionMode();
  enableProdMode();
} else {
  console.log(`Environment : ${ENVIRONMENT.name}`, ENVIRONMENT);
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] });
